﻿{
  "version": 1,
  "gameId": "domino",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "domino.rules.navigationLabel",
    "kickerKey": "domino.rules.kicker",
    "titleKey": "domino.rules.title",
    "summaryKey": "domino.rules.summary",
    "sections": [
      { "id": "setup", "key": "domino.rules.setup" },
      { "id": "match", "key": "domino.rules.match" },
      { "id": "draw", "key": "domino.rules.draw" },
      { "id": "win", "key": "domino.rules.win" },
      { "id": "blocked", "key": "domino.rules.blocked" },
      { "id": "modes", "key": "domino.rules.modes" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {
    "tileSkins": [
      {
        "id": "classic",
        "nameKey": "domino.skin.classic",
        "price": 0,
        "atlas": "/assets/domino/domino-atlas.png",
        "back": "/assets/domino/domino-back.png"
      },
      {
        "id": "toon-wood",
        "nameKey": "domino.skin.toonWood",
        "price": 140,
        "atlas": "/assets/domino/skins/toon-wood-atlas.png",
        "back": "/assets/domino/skins/toon-wood-back.png"
      },
      {
        "id": "terracotta",
        "nameKey": "domino.skin.terracotta",
        "price": 160,
        "atlas": "/assets/domino/skins/terracotta-atlas.png",
        "back": "/assets/domino/skins/terracotta-back.png"
      },
      {
        "id": "brushed-steel",
        "nameKey": "domino.skin.brushedSteel",
        "price": 180,
        "atlas": "/assets/domino/skins/brushed-steel-atlas.png",
        "back": "/assets/domino/skins/brushed-steel-back.png"
      },
      {
        "id": "vintage-oak",
        "nameKey": "domino.skin.vintageOak",
        "price": 220,
        "atlas": "/assets/domino/skins/vintage-oak-atlas.png",
        "back": "/assets/domino/skins/vintage-oak-back.png"
      },
      {
        "id": "granite-stone",
        "nameKey": "domino.skin.graniteStone",
        "price": 260,
        "atlas": "/assets/domino/skins/granite-stone-atlas.png",
        "back": "/assets/domino/skins/granite-stone-back.png"
      },
      {
        "id": "dark-walnut",
        "nameKey": "domino.skin.darkWalnut",
        "price": 300,
        "atlas": "/assets/domino/skins/dark-walnut-atlas.png",
        "back": "/assets/domino/skins/dark-walnut-back.png"
      },
      {
        "id": "obsidian-glass",
        "nameKey": "domino.skin.obsidianGlass",
        "price": 360,
        "atlas": "/assets/domino/skins/obsidian-glass-atlas.png",
        "back": "/assets/domino/skins/obsidian-glass-back.png"
      },
      {
        "id": "royal-gold",
        "nameKey": "domino.skin.royalGold",
        "price": 450,
        "atlas": "/assets/domino/skins/royal-gold-atlas.png",
        "back": "/assets/domino/skins/royal-gold-back.png"
      }
    ]
  }
}
